<div
  class="template image"
  [class.full-screen]="mediaConfig.fullscreen"
  [class.cover-parent]="mediaConfig.coverParent"
  [class.for-print]="isPrintView"
  [class.animated]="animated$ | async">
  <img
    class="template-image"
    alt="CFS Custom image template"
    [src]="url"
    (load)="onLoad()"
    (error)="onError()">
</div>
